const psvResults = [
  {"value": "", "label": ""},
  {"value":"VERIFIED", "label":"Verified"},
  {"value":"FLAGGED", "label":"Verified-Flagged"},
  {"value":"OTHER", "label":"Other"},
];

export default psvResults;